import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useFeatureFlags } from '@shared/hooks/useFeatureFlags'

import { MEETING_STATUS_COUNTS_TO_LABEL_MAP, MEETING_STATUS_ORDER, MEETING_STATUS_TO_COLOR_MAP } from '../../constants'
import { CompanyContactHistoryCounts, MeetingStatus } from '../../types'
import { MeetingStatusDot } from './index.styles'

interface ContactCountsProps {
  counts: CompanyContactHistoryCounts
}

const ContactCounts = (props: ContactCountsProps) => {
  const { counts } = props
  const { t } = useTranslation()
  const { shouldUpgradeToPayingUser } = useFeatureFlags()

  return (
    <Box>
      <Box marginBottom="8px">
        <Typography variant="caption">
          {`${t(
            shouldUpgradeToPayingUser
              ? translationKeys.MEETING_STATUS_HISTORY_TITLE_FOR_FREE_USER
              : translationKeys.MEETING_STATUS_HISTORY_TITLE_FOR_PREMIUM_USER,
          )}: `}
        </Typography>
      </Box>
      <Box display="flex" flexWrap="wrap">
        {MEETING_STATUS_ORDER.map(status =>
          counts[status] ? (
            <Box display="flex" alignItems="center" mr="7px" mb="2px" flex="0 0 auto" key={status}>
              <MeetingStatusDot $color={MEETING_STATUS_TO_COLOR_MAP[status as MeetingStatus]?.bar} />
              <Typography variant="body1">
                {t(MEETING_STATUS_COUNTS_TO_LABEL_MAP[status as MeetingStatus], { count: counts[status] })}
              </Typography>
            </Box>
          ) : null,
        )}
      </Box>
    </Box>
  )
}

export default ContactCounts
